import {
  getCountry,
  getcouponstagwise,
  gettagstearwise,
  getAllGroupDataForProductCatalogue,
} from "Listfunction";
import CreateCataloguePackageDetailsForm from "./AddCataloguePackageDetails/AddCataloguePackageDetailsForm";

import React, { useEffect, useState, useRef } from "react";
import CataloguePackageFeatureDetailsForm from "./AddCataloguePackageDetails/addCataloguePackageFeatureDetails";
import { getAllSpecialty } from "Listfunction";
import { GetAllDoctors } from "Listfunction";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import { addNewPackage } from "Listfunction";
import NotificationSystem from "react-notification-system";
import { useHistory } from "react-router-dom";
import ScreenLoader from "views/Components/screenLoader";

const AddCataloguePackage = (props) => {
  const notificationSystemRef = useRef(null);
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const [countryData, setCountryData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [packageLogo, setPackageLogo] = useState("");
  const [tags, setTags] = useState("");
  const [selectedTiers, setSelectedTiers] = useState("");
  const [selectedTags, setSelectedTags] = useState("");
  const [couponList, setCouponList] = useState([]);
  const [tagListOption, setTagListOption] = useState([]);
  const [packageLogoError, setPackageLogoError] = useState(null);
  const [packageName, setPackageName] = useState("");
  const [productCode, setProductCode] = useState("");
  const [country, setCountry] = useState({ value: "LK", label: "Sri Lanka" });
  const [duration, setDuration] = useState("");
  const [discountPrice, setDiscountPrice] = useState("");
  const [durationType, setDurationType] = useState("");
  const [specialtyListOption, setSpecialtyListOption] = useState([]);
  const [doctorListOption, setDoctorListOption] = useState([]);
  const [deliveryWelcomeNote, setDeliveryWelcomeNote] = useState("");
  const [noOfFreeDelivery, setNoOfFreeDelivery] = useState("");
  const [noOfFreeValue, setNoOfFreeValue] = useState("");
  const [packageLogoUrl, setPackageLogoUrl] = useState("");
  const [oldCompanyLogoFile, setOldCompanyLogoFile] = useState("");
  const [processing, setProcessing] = useState(false);
  const [packageNameError, setPackageNameError] = useState(null);
  const [packageDurationError, setPackageDurationError] = useState(null);
  const [packagePriceError, setPackagePriceError] = useState(null);
  const [countryError, setCountryError] = useState(null);
  const [claimValueError, setClaimValueError] = useState(null);
  const [ipdClaimValueError, setIpdClaimValueError] = useState(null);
  const [userType, setUserType] = useState("1");
  const [packageType, setPackageType] = useState("1");
  const [isFeatured, setIsFeatured] = useState("0");
  const [freeTrialType, setFreeTrialType] = useState("");
  const [freeTrial, setFreeTrial] = useState("");
  const [packagePrice, setPackagePrice] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFormGroup, setSelectedFormGroup] = useState("packageName");
  const [featureError, setFeatureError] = useState(null);
  const [featureDetails, setFeatureDetails] = useState([
    {
      id: 6,
      chk_value: 6,
      label: "Medicine",
      checked: false,
      placeholder: "Enter Discount",
      name: "medicine_discount",
      input_value: "",
      errorMessage: "Medicine discount is required.",
      isFlashCredit: true,
    },
    {
      id: 3,
      chk_value: 3,
      label: "Lab",
      checked: false,
      placeholder: "Enter Discount",
      name: "lab_discount",
      input_value: "",
      errorMessage: "Lab Discount is required.",
      isFlashCredit: true,
    },
    // {
    //   id: 2,
    //   chk_value: 2,
    //   label: "Raya",
    //   checked: false,
    //   placeholder: "Enter Discount",
    //   name: "raya_flat_discount",
    //   input_value: "",
    //   errorMessage: "Raya Discount is required.",
    //   isFlashCreditRaya: true,
    // },
    {
      id: 4,
      chk_value: 4,
      label: "MBE",
      checked: false,
      placeholder: "MBE Price",
      name: "mbe_price",
      input_value: "",
      errorMessage: "MBE Price is required.",
    },
    {
      id: 1,
      chk_value: 1,
      label: "Talk now",
      checked: false,
      placeholder: "Talk now",
      name: "no_of_calls",
      input_value: "",
      errorMessage: "Talk now is required.",
      unlimited: false,
      isFlashCredit: true,
    },
    {
      id: 10,
      chk_value: 10,
      label: "Talk global",
      checked: false,
      placeholder: "Talk global ",
      name: "no_of_talk_global_calls",
      input_value: "",
      errorMessage: "Talk Later Global is required.",
      unlimited: false,
      isFlashCredit: true,
    },
    {
      id: 11,
      chk_value: 11,
      label: "Talk later",
      checked: false,
      placeholder: "Talk later",
      name: "no_of_talk_later_calls",
      input_value: "",
      errorMessage: "Talk Later is required.",
      unlimited: false,
      isFlashCredit: true,
    },
    {
      id: 8,
      chk_value: 8,
      label: "Talk later speciality",
      checked: false,
      placeholder: "Talk later",
      name: "no_of_calls_talk_later",
      input_value: [{ specialty: "", noOfCalls: "" }],
      unlimited: false,
      errorMessage: "Talk later is required.",
    },
    {
      id: 5,
      chk_value: 5,
      label: "Delivery",
      checked: false,
      placeholder: "N.O Deliveries",
      name: "delivery",
      input_value: [
        {
          type: "standard",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "express",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "island_wide",
          free: null,
          discount: null,
          base_price: null,
        },
      ],
      errorMessage: "N.O Delivery is required.",
      standard: false,
      express: false,
      islandWide: false,
    },
    // {
    //   id: 7,
    //   chk_value: 7,
    //   label: "Insurance",
    //   checked: false,
    //   placeholder: "N.O Insurance",
    //   name: "no_of_insurance_order",
    //   input_value: [],
    //   addresslist: [],
    //   errorMessage: "N.O Insurance order is required.",
    // },
    {
      id: 9,
      chk_value: 9,
      label: "Partner & Coupon Management",
      checked: false,
      placeholder: "Partner & Coupon Management",
      name: "partner_and_coupon_management",
      value: [],
      errorMessage: "Partner & Coupon Management is required.",
    },
    {
      id: 12,
      chk_value: 12,
      label: "MBE Groups",
      checked: false,
      placeholder: "Select Group",
      name: "group",
      value: [],
      errorMessage: "Group is required.",
    },
    {
      id: 13,
      chk_value: 13,
      label: "Claim Module",
      checked: false,
      name: "claim",
      value: [],
      isBankAccountNeeded: true,
      isSystemClaimAllowed: true,
      pharma: "Pharma",
      consult: "Consult",
      lab: "Lab",
      errorMessage: "Claim is required.",
    },
    {
      id: 14,
      chk_value: 14,
      label: "Talk Later Doctor wise",
      checked: false,
      name: "talkLaterDoctorWise",
      input_value: [{ doctors: null, no_of_calls: "" }],
      errorMessage: "Talk later doctor is required.",
    },
  ]);

  const fetchCountryData = async () => {
    try {
      const response = await getCountry(obj);
      const data = response.data;
      setCountryData(data);
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };

  const fetchGroupData = async () => {
    try {
      const response = await getAllGroupDataForProductCatalogue(obj);
      const data = response.data;
      const groups = data && data.data ? data.data : data;
      setGroupData(Array.isArray(groups) ? groups : []);
    } catch (error) {
      console.error("Error fetching group data:", error);
    }
  };

  const addSpecialtyRow = (index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].input_value.push({
      specialty: "",
      noOfCalls: "",
    });
    setFeatureDetails(updatedFeatures);
  };

  const onChangeTags = async (event) => {
    const value = event.target.value;

    setSelectedTags(value);
    if (!obj) return;

    try {
      const res = await getcouponstagwise(value, selectedTiers, obj);
      const data = res.data || {};
      const couponOptions = Array.isArray(data.coupons)
        ? data.coupons.map((c) => ({ id: c.id, title: c.title }))
        : [];
      setCouponList(couponOptions);
    } catch (err) {
      console.error("Error fetching coupons by tag", err);
    }
  };

  const onChangeTier = async (event) => {
    const value = event.target.value;
    setSelectedTiers(value);
    if (!obj) return;

    try {
      const res = await gettagstearwise(value, obj);
      const data = res.data;
      const tagOptions = Array.isArray(data.tags)
        ? data.tags.map((x) => ({ value: x, label: x }))
        : [];
      setTagListOption(tagOptions);
    } catch (err) {
      console.error("Error fetching tags by tier", err);
    }
  };

  const uploadPackageLogo = () => {
    document.getElementById("selectpackage_logo").click();
  };

  const handlePackageLogoFileChange = (event) => {
    setPackageLogo(event.target.files[0]);
    setPackageLogoError(null);
  };

  const getAllSpecialties = async () => {
    try {
      const specialties = await getAllSpecialty(obj);
      const specialityOptions = specialties.data.data.map((spec) => ({
        value: spec.id,
        label: spec.title,
      }));
      setSpecialtyListOption(specialityOptions);
    } catch (error) {
      console.error("Error fetching specialties:", error);
    }
  };

  const getAllDoctors = async () => {
    try {
      const response = await GetAllDoctors(obj);
      const mdata = response.data.data;
      const doctorOptions = mdata.map((data) => ({
        value: data.id,
        label: data.name,
      }));
      setDoctorListOption(doctorOptions);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  const onSpecialityChange = (value, i, idx) => {
    const updatedFeatures = [...featureDetails];
    // Store the entire selected object for react-select
    updatedFeatures[i].input_value[idx].specialty = value;
    setFeatureDetails(updatedFeatures);
  };

  const onCallChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value)) {
      const updatedFeatures = [...featureDetails];
      updatedFeatures[i].input_value[idx].noOfCalls = e.target.value;
      setFeatureDetails(updatedFeatures);
    }
  };

  const handleAllCheckedFreeDelivery = (checked, i) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[i].checked = checked;

    if (!checked) {
      updatedFeatures[i].input_value = [
        {
          type: "standard",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "express",
          free: null,
          discount: null,
          base_price: null,
        },
        {
          type: "islandWide",
          free: null,
          discount: null,
          base_price: null,
        },
      ];
      updatedFeatures[i].more = false;
      updatedFeatures[i].standard = false;
      updatedFeatures[i].express = false;
      updatedFeatures[i].islandWide = false;
      setDeliveryWelcomeNote("");
      setNoOfFreeDelivery("");
    }

    setFeatureDetails(updatedFeatures);
    setNoOfFreeValue("");
  };

  // Partner & Coupon Management functions
  const onCouponAdd = (e, index) => {
    const value = e.target.value;
    if (!value) return;

    const updatedFeatures = [...featureDetails];
    const feature = updatedFeatures[index];
    const selectedCoupons = Array.isArray(feature.selectedCoupons)
      ? feature.selectedCoupons
      : [];

    const existing = selectedCoupons.some(
      (c) => String(c.id) === String(value),
    );
    if (existing) {
      e.target.value = "";
      return;
    }

    const found = couponList.find((c) => String(c.id) === String(value));
    const optionText =
      e.target.options && e.target.selectedIndex >= 0
        ? e.target.options[e.target.selectedIndex].text
        : "";

    const entry = found
      ? {
          ...found,
          label: found.label || found.title || optionText || value.toString(),
          title: found.title || found.label || optionText || value.toString(),
        }
      : {
          id: value,
          title: optionText || value.toString(),
          label: optionText || value.toString(),
        };

    const list = [...selectedCoupons];
    list.push(entry);
    updatedFeatures[index].selectedCoupons = list;

    setFeatureDetails(updatedFeatures);
    e.target.value = "";
  };

  const onRemoveCoupon = (id, index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].selectedCoupons = (
      updatedFeatures[index].selectedCoupons || []
    ).filter((c) => String(c.id) !== String(id));
    setFeatureDetails(updatedFeatures);
  };

  // MBE Groups functions
  const onGroupAdd = (e, index) => {
    const value = e.target.value;
    if (!value) return;

    const updatedFeatures = [...featureDetails];
    const selectedGroups = Array.isArray(updatedFeatures[index].value)
      ? updatedFeatures[index].value
      : [];

    const exists = selectedGroups.some((g) => String(g.id) === String(value));
    if (exists) {
      e.target.value = "";
      return;
    }

    const match = groupData.find((g) => String(g.id) === String(value));
    const optionText =
      e.target.options && e.target.selectedIndex >= 0
        ? e.target.options[e.target.selectedIndex].text
        : "";

    const entry = match || {
      id: value,
      group_name: optionText || value.toString(),
    };

    const list = [...selectedGroups];
    list.push(entry);
    updatedFeatures[index].value = list;

    setFeatureDetails(updatedFeatures);
    e.target.value = "";
  };

  const onGroupRemove = (id, index) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index].value = (updatedFeatures[index].value || []).filter(
      (g) => String(g.id) !== String(id),
    );
    setFeatureDetails(updatedFeatures);
  };

  // Claim Module functions
  const updateClaimField = (index, field, value) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      [field]: value,
    };
    setFeatureDetails(updatedFeatures);
  };

  const toggleClaimCheckbox = (index, field, checked) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      [field]: checked,
    };
    if (field === "isUnlimitedClaim" && checked) {
      updatedFeatures[index].claimValue = "";
    }
    setFeatureDetails(updatedFeatures);
  };

  // Talk Later Doctor wise functions
  const onDoctorChange = (selected, index, docIdx) => {
    const updatedFeatures = [...featureDetails];
    if (
      updatedFeatures[index].input_value &&
      updatedFeatures[index].input_value[docIdx]
    ) {
      updatedFeatures[index].input_value[docIdx].doctors = selected;
    }
    setFeatureDetails(updatedFeatures);
  };

  const onDoctorCallChange = (e, index, docIdx) => {
    if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
      const updatedFeatures = [...featureDetails];
      if (
        updatedFeatures[index].input_value &&
        updatedFeatures[index].input_value[docIdx]
      ) {
        updatedFeatures[index].input_value[docIdx].no_of_calls = e.target.value;
      }
      setFeatureDetails(updatedFeatures);
    }
  };

  const addDoctorRow = (index) => {
    const updatedFeatures = [...featureDetails];
    const list = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];
    list.push({ doctors: null, no_of_calls: "" });
    updatedFeatures[index].input_value = list;
    setFeatureDetails(updatedFeatures);
  };

  const removeDoctorRow = (index, rowIndex) => {
    const updatedFeatures = [...featureDetails];
    const inputArray = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];
    const filteredRows = inputArray.filter((item, idx) => idx !== rowIndex);
    updatedFeatures[index].input_value =
      filteredRows.length > 0
        ? filteredRows
        : [{ doctors: "", no_of_calls: "" }];
    setFeatureDetails(updatedFeatures);
  };

  const removeSpecialtyRow = (index, rowIndex) => {
    const updatedFeatures = [...featureDetails];
    const inputArray = Array.isArray(updatedFeatures[index].input_value)
      ? [...updatedFeatures[index].input_value]
      : [];

    // Filter out the row at the specified rowIndex
    const filteredRows = inputArray.filter((item, idx) => idx !== rowIndex);

    // If no rows remain, reset to initial state with one empty row
    updatedFeatures[index].input_value =
      filteredRows.length > 0
        ? filteredRows
        : [{ specialty: "", noOfCalls: "" }];

    setFeatureDetails(updatedFeatures);
  };

  console.log("AAAAA", featureDetails);
  // State for form group selection

  // Refs for form groups
  const packageNameRef = useRef(null);
  const countryRef = useRef(null);
  const packageLogoRef = useRef(null);
  const pricingRef = useRef(null);
  const featureDetailsRef = useRef(null);
  const durationRef = useRef(null);

  // Form group options
  const formGroupOptions = [
    { value: "packageName", label: "Package Name" },
    { value: "country", label: "Country" },
    { value: "packageLogo", label: "Package Logo" },
    { value: "pricing", label: "Pricing Details" },
    { value: "featureDetails", label: "Feature Details" },
    { value: "duration", label: "Duration" },
  ];

  // Handle focus on selected form group
  const handleFocusFormGroup = (selectedFormGroup) => {
    console.log("AAAA", selectedFormGroup);
    const refMap = {
      packageName: packageNameRef,
      country: countryRef,
      packageLogo: packageLogoRef,
      pricing: pricingRef,
      featureDetails: featureDetailsRef,
      duration: durationRef,
    };

    const selectedRef = refMap[selectedFormGroup];
    if (selectedRef && selectedRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Try to focus input if it exists
      const input = selectedRef.current.querySelector("input");
      if (input) {
        setTimeout(() => input.focus(), 200);
      }
    }
  };

  const onSubmit = async () => {
    let error = false;
    const hasCheckedFeature = featureDetails.some((f) => f.checked);
    if (!hasCheckedFeature) {
      error = true;
      handleFocusFormGroup("featureDetails");
      setFeatureError(
        <small className="text-danger">Feature is required.</small>,
      );
    }

    const getClaimFeatureData = featureDetails.find(
      (data) => data.chk_value === 13,
    );
    if (getClaimFeatureData && getClaimFeatureData.checked) {
      if (
        (!getClaimFeatureData.claimValue ||
          getClaimFeatureData.claimValue === "") &&
        !getClaimFeatureData.isUnlimitedClaim
      ) {
        error = true;
        setClaimValueError(
          <small className="text-danger">
            Claim allocation or unlimited claim is required.
          </small>,
        );
      } else {
        setClaimValueError(null);
      }
      if (
        getClaimFeatureData.hospital &&
        (getClaimFeatureData.ipdClaimValue == undefined ||
          getClaimFeatureData.ipdClaimValue === "" ||
          getClaimFeatureData.ipdClaimValue === null)
      ) {
        error = true;
        const errorMessage = (
          <small className="text-danger">
            IPD Claim allocation is required.
          </small>
        );
        setIpdClaimValueError(errorMessage);
      } else {
        setIpdClaimValueError(null);
      }
    }
    if (!packageName || packageName.length === 0) {
      handleFocusFormGroup("packageName");
      error = true;
      setPackageNameError(
        <small className="text-danger">Package Name is required.</small>,
      );
    } else {
      setPackageNameError(null);
    }

    if (!duration || duration.length === 0) {
      error = true;
      handleFocusFormGroup("duration");
      setPackageDurationError(
        <small className="text-danger">Duration is required.</small>,
      );
    } else {
      setPackageDurationError(null);
    }

    if (!packagePrice || packagePrice.length === 0) {
      error = true;
      handleFocusFormGroup("pricing");
      setPackagePriceError(
        <small className="text-danger">Price is required.</small>,
      );
    } else {
      setPackagePriceError(null);
    }

    if (!country || country === "0") {
      error = true;
      handleFocusFormGroup("country");
      setCountryError(
        <small className="text-danger">Country is required.</small>,
      );
    } else {
      setCountryError(null);
    }
    if (!packageLogo && !logoUrlToUse) {
      handleFocusFormGroup("packageLogo");
      error = true;
      setPackageLogoError(
        <small className="text-danger">Package logo is required.</small>,
      );
    } else {
      setPackageLogoError(null);
    }

    let logoUrlToUse = packageLogoUrl; // Start with existing URL

    try {
      if (packageLogo && packageLogo.length !== 0) {
        setProcessing(true);
        const fdata = new FormData();
        fdata.append("company_logo", packageLogo);

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "X-Request-Id": "124",
          },
          body: fdata,
        });

        const res = await response.json();
        if (res.data && res.data.company_logo_url) {
          logoUrlToUse = res.data.company_logo_url;
          setPackageLogoUrl(logoUrlToUse);
        }
        setProcessing(false);
      }
    } catch (error) {
      console.error("Logo upload error:", error);
      setProcessing(false);
    }

    if (!error) {
      setIsLoading(true);
      const featureData = [];
      const payload = featureDetails.map((feature) => {
        if (feature.name == "no_of_calls_talk_later") {
          if (feature.checked) {
            let talkLaterSpeciality = [];
            for (let xi = 0; xi < feature.input_value.length; xi++) {
              let specialtyId = feature.input_value[xi].specialty
                ? feature.input_value[xi].specialty.value
                : "";

              talkLaterSpeciality.push({
                speciality_id: specialtyId,
                no_of_calls: feature.input_value[xi].noOfCalls,
              });
            }
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: talkLaterSpeciality,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "delivery") {
          const deliveryOptions = feature.input_value.map((option) => ({
            type: option.type,
            free: option.free,
            discount: option.discount,
            base_price: option.base_price,
          }));
          deliveryOptions.push({
            type: "sum",
            t_count: noOfFreeDelivery,
          });
          let deliveryPayload = deliveryOptions;
          featureData.push({
            category_id: feature.chk_value,
            title: feature.name,
            value: deliveryPayload,
          });
        } else if (feature.name === "claim") {
          if (feature.checked) {
            const manualClaimFeature = [
              feature.pharma && feature.pharma !== "" ? feature.pharma : null,
              feature.lab && feature.lab !== "" ? feature.lab : null,
              feature.consult && feature.consult !== ""
                ? feature.consult
                : null,
              feature.hospital && feature.hospital !== ""
                ? feature.hospital
                : null,
            ].filter((item) => item !== null);
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [
                {
                  value: feature.claimValue,
                  medicine: feature.isClaimMedicine || false,
                  lab: feature.isClaimLab || false,
                  raya: feature.isClaimRaya || false,
                  talkNow: feature.isClaimTalkNow || false,
                  talkLater: feature.isClaimTalkLater || false,
                  talkGlobal: feature.isClaimTalkGlobal || false,
                  eChanneling: feature.isClaimEchanneling || false,
                  hospitalization: feature.isHospitalization || false,
                  talkFamily: feature.isClaimFamily || false,
                  talkFamilyMother:
                    (feature.isClaimFamily && feature.isClaimMother) || false,
                  talkFamilyFather:
                    (feature.isClaimFamily && feature.isClaimFather) || false,
                  talkFamilyBrother:
                    (feature.isClaimFamily && feature.isClaimBrother) || false,
                  talkFamilySister:
                    (feature.isClaimFamily && feature.isClaimSister) || false,
                  talkFamilySpouse:
                    (feature.isClaimFamily && feature.isClaimSpouse) || false,
                  talkFamilyChild:
                    (feature.isClaimFamily && feature.isClaimChild) || false,
                  creditType: 4,
                  opdIndividual: feature.opdIndividualPrice,
                  opdFamilyPrice: feature.opdFamilyPrice,
                  billingCycle: feature.claimBillingCycle,
                  isUnlimitedAllocation: feature.isUnlimitedClaimAllocation,
                  isSystemClaimAllowed: feature.isSystemClaimAllowed,
                  isBankAccountNeeded: feature.isBankAccountNeeded,
                  poolValue: feature.poolValue,
                  manualClaims: manualClaimFeature,
                  claimType: feature.claimType,
                  ipdClaimValue: feature.ipdClaimValue,
                },
              ],
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "talkLaterDoctorWise") {
          if (
            feature.checked &&
            feature.input_value &&
            feature.input_value.length > 0
          ) {
            const selectedDoctorId = feature.input_value.map((item) => {
              return {
                doctorId:
                  item.doctors && item.doctors.value
                    ? item.doctors.value
                    : null,
                noOfCalls: item.no_of_calls,
              };
            });
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedDoctorId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "group") {
          if (feature.checked && feature.value && feature.value.length > 0) {
            const selectedGroupId = feature.value.map((group) => group.id);
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedGroupId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else if (feature.name === "partner_and_coupon_management") {
          if (
            feature.checked &&
            feature.selectedCoupons &&
            feature.selectedCoupons.length > 0
          ) {
            const selectedCouponId = feature.selectedCoupons.map(
              (coupon) => coupon.id,
            );
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: selectedCouponId,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: [],
            });
          }
        } else {
          if (feature.checked) {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: feature.value || feature.input_value,
              is_flash_credit_usable: feature.isFlashCredit || false,
              unlimited: feature.unlimited || false,
            });
          } else {
            featureData.push({
              category_id: feature.chk_value,
              title: feature.name,
              value: "",
            });
          }
        }
      });
      const getPolicy = featureDetails.find(
        (feature) => feature.name === "claim" && feature.claimPolicyDetails,
      );
      let policyPayload = [];
      const xxx = featureDetails.map((feature) => {
        if (
          feature.name === "claim" &&
          feature.claimPolicyDetails &&
          feature.checked &&
          getPolicy
        ) {
          if (feature.isClaimMedicine) {
            policyPayload.push({
              title: "medicine",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimLab) {
            policyPayload.push({
              title: "lab",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimRaya) {
            policyPayload.push({
              title: "raya",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimTalkNow) {
            policyPayload.push({
              title: "talkNow",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
          if (feature.isClaimTalkLater) {
            policyPayload.push({
              title: "talkLater",
              value: draftToHtml(
                convertToRaw(
                  feature.claimPolicyDetails.value.getCurrentContent(),
                ),
              ),
            });
          }
        }
      });
      await addNewPackage(
        packageName,
        duration,
        durationType,
        "",
        packagePrice,
        "#00A651",
        featureData,
        Number(userType),
        Number(packageType),
        "",
        "",
        isFeatured,
        freeTrialType,
        freeTrial,
        discountPrice,
        productCode,
        country.value,
        logoUrlToUse,
        policyPayload,
        obj,
      )
        .then((res) => {
          if (res.data.success === true) {
            handleSuccess("bl");
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          handleNetworkError("bl");
        });
    }
  };

  const handleSuccess = (position) => {
    if (notificationSystemRef.current) {
      notificationSystemRef.current.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Catalogue Package</b> - Created Successfully.
          </div>
        ),
        level: "success",
        position: position,
        autoDismiss: 15,
      });
      setTimeout(() => {
        props.history.push("/admin/productcatalogue");
      }, 500);
    }
  };

  const handleNetworkError = (position) => {
    if (notificationSystemRef.current) {
      notificationSystemRef.current.addNotification({
        title: <span data-notify="icon" className="pe-7s-close"></span>,
        message: (
          <div>
            <b>Error</b> - Failed to create package.
          </div>
        ),
        level: "error",
        position: position,
        autoDismiss: 15,
      });
    }
  };
  const updatePolicyField = (index, type, editorState) => {
    const updatedFeatures = [...featureDetails];
    updatedFeatures[index] = {
      ...updatedFeatures[index],
      claimPolicyDetails: { value: editorState },
    };
    setFeatureDetails(updatedFeatures);
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          fetchCountryData(),
          fetchGroupData(),
          getAllSpecialties(),
          getAllDoctors(),
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
      } finally {
      }
    };

    loadData();
  }, []);
  const onCallUnlimitedChange = (e, index, specIndex) => {
    const updated = [...featureDetails];
    const item = {
      ...updated[index].input_value[specIndex],
    };
    item.unlimited = e.target.checked;
    if (e.target.checked) {
      item.noOfCalls = "unlimited";
    } else {
      item.noOfCalls = "";
    }
    updated[index].input_value[specIndex] = item;
    setFeatureDetails(updated);
  };
  return (
    <>
      <NotificationSystem ref={notificationSystemRef} />
      {isLoading && <ScreenLoader />}
      <CreateCataloguePackageDetailsForm
        countryData={countryData}
        groupData={groupData}
        packageLogo={packageLogo}
        packageLogoUrl={packageLogoUrl}
        packageLogoError={packageLogoError}
        uploadPackageLogo={uploadPackageLogo}
        handlePackageLogoFileChange={handlePackageLogoFileChange}
        featureDetails={featureDetails}
        setFeatureDetails={setFeatureDetails}
        addSpecialtyRow={addSpecialtyRow}
        onChangeTags={onChangeTags}
        onChangeTier={onChangeTier}
        tagListOption={tagListOption}
        couponList={couponList}
        packageName={packageName}
        setPackageName={setPackageName}
        productCode={productCode}
        setProductCode={setProductCode}
        userType={userType}
        setUserType={setUserType}
        packageType={packageType}
        setPackageType={setPackageType}
        isFeatured={isFeatured}
        setIsFeatured={setIsFeatured}
        freeTrialType={freeTrialType}
        setFreeTrialType={setFreeTrialType}
        freeTrial={freeTrial}
        setFreeTrial={setFreeTrial}
        duration={duration}
        setDuration={setDuration}
        discountPrice={discountPrice}
        setDiscountPrice={setDiscountPrice}
        durationType={durationType}
        setDurationType={setDurationType}
        specialtyListOption={specialtyListOption}
        doctorListOption={doctorListOption}
        country={country}
        setCountry={setCountry}
        getAllDoctors={getAllDoctors}
        onSpecialityChange={onSpecialityChange}
        onCallChange={onCallChange}
        handleAllCheckedFreeDelivery={handleAllCheckedFreeDelivery}
        deliveryWelcomeNote={deliveryWelcomeNote}
        setDeliveryWelcomeNote={setDeliveryWelcomeNote}
        noOfFreeDelivery={noOfFreeDelivery}
        setNoOfFreeDelivery={setNoOfFreeDelivery}
        noOfFreeValue={noOfFreeValue}
        setNoOfFreeValue={setNoOfFreeValue}
        selectedTiers={selectedTiers}
        selectedTags={selectedTags}
        setSelectedTags={setSelectedTags}
        setSelectedTiers={setSelectedTiers}
        onCouponAdd={onCouponAdd}
        onRemoveCoupon={onRemoveCoupon}
        onGroupAdd={onGroupAdd}
        onGroupRemove={onGroupRemove}
        updateClaimField={updateClaimField}
        toggleClaimCheckbox={toggleClaimCheckbox}
        onDoctorChange={onDoctorChange}
        onDoctorCallChange={onDoctorCallChange}
        addDoctorRow={addDoctorRow}
        removeDoctorRow={removeDoctorRow}
        removeSpecialtyRow={removeSpecialtyRow}
        onSubmit={onSubmit}
        packagePrice={packagePrice}
        setPackagePrice={setPackagePrice}
        processing={processing}
        packageNameError={packageNameError}
        packageDurationError={packageDurationError}
        packagePriceError={packagePriceError}
        countryError={countryError}
        claimValueError={claimValueError}
        ipdClaimValueError={ipdClaimValueError}
        setCountryError={setCountryError}
        setPackageNameError={setPackageNameError}
        setPackageDurationError={setPackageDurationError}
        setPackagePriceError={setPackagePriceError}
        setClaimValueError={setClaimValueError}
        updatePolicyField={updatePolicyField}
        isLoading={isLoading}
        onCallUnlimitedChange={onCallUnlimitedChange}
        packageNameRef={packageNameRef}
        countryRef={countryRef}
        packageLogoRef={packageLogoRef}
        pricingRef={pricingRef}
        featureDetailsRef={featureDetailsRef}
        durationRef={durationRef}
        featureError={featureError}
        setFeatureError={setFeatureError}
      />
    </>
  );
};
export default AddCataloguePackage;
